import ForgotPassword from "pages/authentication/ForgotPassword";
import Login from "pages/authentication/Login";
import Register from "pages/authentication/Register";
import ResetPassword from "pages/authentication/ResetPassword";
import NewEditScript from "pages/editScript";
import SearchResult from "pages/searchResult";
import UploadPage from "pages/uploadScripts";
import UploadScriptAdmin from "pages/uploadScriptAdmins";
import VerificationPage from "pages/VerificationPage";
import LogoutPage from "pages/authentication/LogoutPage";
import ComposerPage from "pages/composer";
import PageNotFound from "components/PageNotFound";

import { PUBLIC_PATHS, PROTECTED_PATHS } from "./pagePath";
import { type AppRoute } from "./types";
import { Navigate } from "react-router-dom";
import WithSuspense from "components/WithSuspense";
import { lazy } from "react";
import AdminDashboardLayout from "pages/adminDashboard/adminDashboardLayout";
import TestApi from "TestApiPage";
import EditComposer from "pages/composer/EditComposer";
import RegisteredUsers from "components/DashboardContents/Users/RegisteredUsers";
import AllUsersCategory from "components/DashboardContents/Users/AllUsersCategory";
import VerifiedUsers from "components/DashboardContents/Users/VerifiedUsers";
import ActiveUsers from "components/DashboardContents/Users/ActiveUsers";
import WeeklyDownloads from "components/DashboardContents/MonthlyDownloads";
import Subscribers from "components/DashboardContents/Subscribers";
import Revenue from "components/DashboardContents/Revenue";

const AllComposers = WithSuspense(lazy(async () => await import("pages/composer/AllComposers")));
const DashBoard = WithSuspense(lazy(async () => await import("pages/dashboard")));
const ScriptPage = WithSuspense(lazy(async () => await import("pages/scriptPage")));
const CreateComposer = WithSuspense(
  lazy(async () => await import("pages/composer/CreateComposer")),
);

const { LOGIN, REGISTER, FORGOT_PASS, RESET_PASSWORD, SINGLE_SCRIPT, LOGOUT, SEARCH_RESULT } =
  PUBLIC_PATHS;
/**
 * Our application's public paths are contained here
 * @constant
 */
export const PUBLIC_ROUTES: AppRoute[] = [
  { path: "/", element: <Login /> },
  {
    path: LOGIN,
    element: <Login />,
  },
  { path: REGISTER, element: <Register /> },
  { path: FORGOT_PASS, element: <ForgotPassword /> },
  { path: RESET_PASSWORD, element: <ResetPassword /> },
  { path: LOGOUT, element: <LogoutPage /> },
  ...Object.values(PROTECTED_PATHS).map((route) => {
    return {
      path: route,
      element: <Navigate to="/" />,
    };
  }), // this enables you not to access the Protected routes when not logged in
  { path: "*", element: <PageNotFound /> },
];
const {
  UPLOAD,
  OLD_UPLOAD_ADMIN,
  UPLOAD_ADMIN,
  TEST_ADMIN,
  NEW_EDIT_SCRIPT,
  NEW_COMPOSER,
  EDIT_COMPOSER,
  COMPOSER,
  ALL_COMPOSER,
  DASHBOARD,
  REGISTERED_USERS,
  SUBSCRIBERS,
  WEEKLY_DOWNLOADS,
  USERS_CATEGORY,
  VERIFIED_USERS,
  ACTIVE_USERS,
  REVENUE,
} = PROTECTED_PATHS;

export const PROTECTED_ROUTES: AppRoute[] = [
  { path: "/", element: <DashBoard /> },
  { path: DASHBOARD, element: <AdminDashboardLayout /> },
  { path: NEW_EDIT_SCRIPT, element: <NewEditScript /> },
  { path: UPLOAD, element: <UploadPage /> },
  { path: OLD_UPLOAD_ADMIN, element: <UploadScriptAdmin /> },
  { path: UPLOAD_ADMIN, element: <VerificationPage /> },
  { path: TEST_ADMIN, element: <TestApi /> },
  { path: SINGLE_SCRIPT, element: <ScriptPage /> },
  { path: SEARCH_RESULT, element: <SearchResult /> },
  { path: NEW_COMPOSER, element: <CreateComposer /> },
  { path: EDIT_COMPOSER, element: <EditComposer /> },
  { path: COMPOSER, element: <ComposerPage /> },
  { path: ALL_COMPOSER, element: <AllComposers /> },
  { path: USERS_CATEGORY, element: <AllUsersCategory /> },
  { path: REGISTERED_USERS, element: <RegisteredUsers /> },
  { path: VERIFIED_USERS, element: <VerifiedUsers /> },
  { path: ACTIVE_USERS, element: <ActiveUsers /> },
  { path: WEEKLY_DOWNLOADS, element: <WeeklyDownloads /> },
  { path: SUBSCRIBERS, element: <Subscribers /> },
  { path: REVENUE, element: <Revenue /> },

  ...Object.values(PUBLIC_PATHS).map((route) => {
    return {
      path: route,
      element: <Navigate to="/dashboard" />,
    };
  }), // this enables you not to access the public routes when logged in
  { path: "*", element: <PageNotFound /> },
];
